export type ActionBoardProps = {};

export enum ActionTimeFormat {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
}
